import { render, staticRenderFns } from "./BonusList.vue?vue&type=template&id=0a38f77a&scoped=true&"
import script from "./BonusList.vue?vue&type=script&lang=js&"
export * from "./BonusList.vue?vue&type=script&lang=js&"
import style0 from "./BonusList.vue?vue&type=style&index=0&id=0a38f77a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a38f77a",
  null
  
)

export default component.exports